(() => {
  const dropdowns = document.querySelectorAll('[data-country-code-dropdown]');
  if (!dropdowns.length) return;

  const closeDropdown = (dropdown) => {
    const trigger = dropdown.querySelector('[data-country-code-trigger]');
    const menu = dropdown.querySelector('[data-country-code-list]');
    dropdown.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
  };

  dropdowns.forEach((dropdown) => {
    const hiddenInput = dropdown.querySelector('[data-country-code-value]');
    const trigger = dropdown.querySelector('[data-country-code-trigger]');
    const label = dropdown.querySelector('[data-country-code-label]');
    const menu = dropdown.querySelector('[data-country-code-list]');
    if (!hiddenInput || !trigger || !label || !menu) return;

    const options = Array.from(menu.querySelectorAll('.ui-dropdown__option'));
    const setValue = (option, isInitial = false) => {
      const value = option.dataset.value || '';
      hiddenInput.value = value;
      label.textContent = value;
      options.forEach((node) => {
        const selected = node === option;
        node.classList.toggle('is-selected', selected);
        node.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      if (!isInitial) closeDropdown(dropdown);
    };

    const initial = options.find((opt) => opt.classList.contains('is-selected')) || options[0];
    if (initial) setValue(initial, true);

    trigger.addEventListener('click', () => {
      const willOpen = !dropdown.classList.contains('is-open');
      dropdowns.forEach((node) => closeDropdown(node));
      if (willOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }
    });

    options.forEach((option) => {
      option.addEventListener('click', () => setValue(option));
    });
  });

  document.addEventListener('click', (event) => {
    dropdowns.forEach((dropdown) => {
      if (!dropdown.contains(event.target)) closeDropdown(dropdown);
    });
  });
})();
